import { formatDistanceToNow } from 'date-fns';
import useHydrationSafe from '../../../hooks/use-hydration-safe';
import formatArticlePublishedAt from '../../../utils/format-article-published-at';

type DateTextProps =
    | { format: 'year'; value?: never }
    | { format: 'published' | 'relative'; value?: string | null };

const DateText = ({ format, value }: DateTextProps): string | null => {
    const hydrated = useHydrationSafe();
    // The build and first browser render must not depend on either clock or timezone.
    if (!hydrated) return null;

    if (format === 'year') {
        const year = new Date().getFullYear();
        return String(year);
    }

    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const text = format === 'relative'
        ? formatDistanceToNow(date, { addSuffix: true })
        : formatArticlePublishedAt(date.toISOString());
    return text;
};

export default DateText;
